import { render, staticRenderFns } from "./immediatePay.vue?vue&type=template&id=54681ac2&scoped=true"
import script from "./immediatePay.vue?vue&type=script&lang=js"
export * from "./immediatePay.vue?vue&type=script&lang=js"
import style0 from "./immediatePay.vue?vue&type=style&index=0&id=54681ac2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54681ac2",
  null
  
)

export default component.exports